export const WordPressUtil = {
    findById: (data, id) => {
        if (!data) {
            return null;
        }
        let foundItem = null;
        data.forEach(item => {
            if (item.id === id) {
                foundItem = item;
            }
        })
        return foundItem;
    }
}